<ng-container *ngIf="agreement">
  <div class="add-padding-bottom add-margin-bottom">
    <apex-page-info>
      <T
        title
        str="Agreement"></T>
    </apex-page-info>

    <h2 class="am">
      <ng-container *ngIf="agreement.id">
        {{ agreement.name }}
      </ng-container>
    </h2>

    <form
      (ngSubmit)="save()"
      #agreementForm="ngForm">
      <div class="df c apl apt am mat-elevation-z2">
        <mat-form-field class="amr">
          <input
            [disabled]="disabled$ | async"
            matInput
            type="text"
            name="name"
            [(ngModel)]="agreement.name"
            [placeholder]="'Name' | translate"
            required />
        </mat-form-field>

        <mat-form-field class="amr">
          <textarea
            [disabled]="disabled$ | async"
            matInput
            name="description"
            cdkTextareaAutosize
            cdkAutosizeMinRows="1"
            cdkAutosizeMaxRows="10"
            [placeholder]="'Description' | translate"
            [(ngModel)]="agreement.description">
          </textarea>
        </mat-form-field>

        <apex-object-selector
          [disabled]="disabled$ | async"
          class="amr"
          name="object"
          [label]="'Object' | translate"
          [meta]="MetaType.Commercial"
          [(ngModel)]="agreement.ObjectId"
          required>
        </apex-object-selector>

        <div class="df ac">
          <mat-form-field class="f1 amr">
            <mat-label>
              <T str="Period"></T>
            </mat-label>
            <mat-date-range-input
              [rangePicker]="picker"
              required>
              <input
                [disabled]="disabled$ | async"
                matStartDate
                name="from"
                [(ngModel)]="agreement.from"
                [placeholder]="'Start date' | translate"
                required />
              <input
                [disabled]="disabled$ | async"
                matEndDate
                name="to"
                [(ngModel)]="agreement.to"
                [placeholder]="'End date' | translate" />
            </mat-date-range-input>
            <mat-datepicker-toggle
              matIconSuffix
              [for]="picker">
            </mat-datepicker-toggle>
            <mat-date-range-picker #picker></mat-date-range-picker>
          </mat-form-field>

          <mat-checkbox
            [disabled]="disabled$ | async"
            class="amr"
            name="active"
            [(ngModel)]="agreement.active">
            <T str="Active"></T>
          </mat-checkbox>
        </div>

        <mat-checkbox
          [disabled]="disabled$ | async"
          class="amr amb"
          name="active"
          [(ngModel)]="agreement.requireReports">
          <T str="Require an uploaded report to close the case"></T>
        </mat-checkbox>
        <div class="amr amb p-df p-f1 df jfe">
          <button
            [disabled]="disabled$ | async"
            mat-raised-button
            type="submit"
            color="primary"
            class="p-f1">
            <T str="Save"></T>
          </button>
        </div>
      </div>
    </form>

    <!-- Cases for this agreement -->
    <div
      class="am amb"
      *ngIf="cases.length > 0">
      <apex-case-list [cases]="cases"></apex-case-list>
    </div>

    <div
      *ngIf="!cases.length"
      class="am amb">
      <p class="am apts">
        <T str="No cases found for this agreement"></T>
      </p>
    </div>

    <div *ngIf="agreement.id">
      <apex-repeatable-case-list-new [agreementId]="agreement.id"></apex-repeatable-case-list-new>
    </div>

    <div class="df w aml">
      <!-- left -->
      <div class="df c f1 amr">
        <apex-file-usage
          [allowEdit]="false"
          [disabled]="disabled$ | async"
          #fileUsage
          class="amb"
          view="List"
          [title]="'Files' | translate"
          self="agreement"
          [selfId]="agreement.id || 0"
          name="files">
        </apex-file-usage>

        <apex-file-usage
          [disabled]="disabled$ | async"
          #fileUsagePublic
          class="amb"
          view="List"
          [title]="'Public Files' | translate"
          [description]="'Public files are visible to customers when shared' | translate"
          self="agreement"
          [selfId]="agreement.id || 0"
          name="public-files">
        </apex-file-usage>

        <div
          class="amb"
          *ngIf="agreement.id">
          <apex-model-role
            [disabled]="disabled$ | async"
            model="agreement"
            [modelId]="agreement.id"
            role="involved"
            [label]="'Involved' | translate"
            [title]="'Involved' | translate">
          </apex-model-role>
        </div>

        <!-- Tenants from Object Section -->
        <apex-object-tenant-selector
          *ngIf="agreement.id"
          class="amb"
          [objectId]="Number(agreement.ObjectId)"
          [agreementId]="agreement.id"
          [disabled]="disabled$ | async"
          (tenantAdded)="onTenantAdded()">
        </apex-object-tenant-selector>
      </div>

      <!-- right -->
      <div
        class="df c f1 amr"
        *ngIf="agreement.id">
        <apex-text-usage
          [ngClass]="{ 'pointer-events-disable': (disabled$ | async) === true }"
          class="amb"
          [label]="'External Information' | translate"
          model="agreement"
          [modelId]="agreement.id"
          name="external-information">
        </apex-text-usage>

        <apex-text-usage
          *ngIf="(disabled$ | async) === false"
          class="amb"
          [label]="'Internal Information' | translate"
          model="agreement"
          [modelId]="agreement.id"
          name="internal-information">
        </apex-text-usage>

        <apex-object-fields
          [disabled]="disabled$ | async"
          [objectId]="this.project?.ParentId ?? this.project?.id ?? objectId"
          [agreementId]="agreement.id"></apex-object-fields>
      </div>
    </div>
  </div>
</ng-container>
